import Controller from "../Controller";

export default class IHMozufuruArtifactController extends Controller {
  apply (ih) {
    super.apply(ih);
    $(ih).on('ready', () => {
      // 全選択解除時に一部のファセットを閉じる
      // 主墳・陪塚検索を初期化する
      $('#all-clear-button').on('click', () => {
        ih.isAllSelectionCleared = true;
      });
      $('#all-clear-button-feature').on('click', () => {
        $('.mf-af-search-by-kofun').addClass('ui-disabled');
        this.clearAllSelector();
        ih.searchFromBaseMarker();
        ih.isAllSelectionCleared = true;
      });
      
      $(ih).on('ihAfterRequestPlaces', (event, request, places) => {
        if (places.length === 0) {
          $('.mf-af-search-by-kofun').removeClass('ui-disabled');
        }
      });
      
      $(ih.map).on('ihDisplayedAllMarkers', (event, places, marker, popup) => {
        $('.mf-af-search-by-kofun').removeClass('ui-disabled');
      });
    });
  }
  
  renderFacetSearchMenu () {
    const self = this;
    const ih = this.ih;
    const $typeSearchGroup = $('.js-search-type');
    const $kofunSearchGroup = $('.mf-af-search-by-kofun');
    const kofunFacets = ['出土古墳', '古墳現状', '出土古墳の墳形', '出土古墳の墳丘長2'];
    let elem = $typeSearchGroup;
    let categories = {};
    
    $typeSearchGroup.controlgroup({
      create() {
      }
    });
    $kofunSearchGroup.controlgroup({
      create() {
      }
    });
  
    ih.placeType.getAll().forEach(function (type) {
      if (kofunFacets.indexOf(type.category.name) !== -1) {
        elem = $kofunSearchGroup;
      } else {
        elem = $typeSearchGroup;
      }
      const container = elem.controlgroup('container');
    
      if (type.category && !categories[type.category.id]) {
        // ファセットが非表示指定 (display: 0) でなければファセットを描画
        if ( type.category.display != 0) {
          // ファセットオブジェクト
          let facet = type.category;
          // ファセットを表示する要素
          let fctElem = $('<label class="category-label"></label>');
          // ファセットそのもののチェックボックス (ファセット検索ではチェックボックスは非表示にし、機能も無効にする)
          let fctCheckbox = $('<input type="checkbox" data-theme="e" data-category="' + facet.id + '" class="js-facility-category" />');
        
          // ファセットの描画
          if (facet.name === '出土古墳の墳丘長2') {
            fctElem.append($('<span></span>').text('出土古墳の墳丘長'));
          } else {
            fctElem.append($('<span></span>').text(facet.name));
          }
        
          // ファセットの開閉マークの描画
          const $collapseMarker = $('<span class="ih-collapsible-search-menu-marker" id="ih-collapsible-search-menu-marker-' + facet.id + '"></span>');
          $collapseMarker.data('collapse', false);
          $collapseMarker.data('facetId', facet.id);
          $collapseMarker.text('▼');
          fctElem.append($collapseMarker);
        
          // ファセットチェックボックスの描画
          fctElem.append(fctCheckbox);
        
          // ファセット要素の描画
          container.append(fctElem);
        
          fctCheckbox.checkboxradio();
          categories[facet.id] = facet;
        
          // ファセット値をリストごと開閉する
          fctCheckbox.on('click', function () {
            let checkbox = null;
            let checkedItem = null;
          
            // ファセットの開閉マークを切り替える
            if ( $collapseMarker.data('collapse') ) {
              $collapseMarker.data('collapse', false);
              $collapseMarker.text('▼');
            } else {
              $collapseMarker.data('collapse', true);
              $collapseMarker.text('▲');
            }
          
            $('.js-facet-selector').each(function () {
              if ( $(this).data('category') === facet.id ) {
                checkbox = $(this).closest('.ui-checkbox');
                // 選択中の値やその下位階層の値は常に表示したまま
                if ( $(this).prop('checked') ) {
                  checkedItem = $(this).data('placetype');
                } else if ( $(this).data('parent_id') && $(this).data('parent_id') === checkedItem && !$(this).data('hide') ) {
                  if (!this.isMasterServantSearchMode && facet.id != 14) {
                    checkbox.show();
                  }
                } else if (!$(this).data('hide')) {
                  checkbox.toggle();
                }
              }
            });
          });
        }
      }
    
      // 非表示指定値を持つファセット値（描画中のファセット値に該当するもの）を取得
      // 　・描画中のファセット値オブジェクト(type)は非表示指定値を持っていない
      // 　・typeが持つファセットオブジェクト(type.category)の中のファセット値
      // 　　オブジェクト(type.category.items)の各ファセット値は非表示指定値を
      // 　　持っている
      let _facet = _.find(type.category.items, function (itm) {
        return itm.id == type.id;
      });
    
      // ファセット値、及びそのファセット値が属するファセットが非表示指定でなければ、ファセット値を描画
      if ( type.category.display != 0 && _facet.display != 0 ) {
        //ファセット値の親要素を調べる
        let facet_id = type.id;
        let parent;
        let parent_id;
        type.category.items.forEach(function (item) {
          //parent_idを取得
          if (item.parent_id && facet_id == item.id) {
            parent_id = item.parent_id;
          }
        });
        if (parent_id) {
          //parent_idから親要素を取得
          type.category.items.forEach(function (item) {
            if (item.id == parent_id) {
              parent = item;
            }
          });
        }
        
        // ファセット値を表示する要素
        let fcvElem = $('<label class="js-tooltip" data-last-child="false" data-target="place-help-' + type.id + '" parent-id="' + parent_id + '"></label>');
        // 検索結果数を表示する要素
        let cntElem = $('<span class="js-facet-count search-count-circle" data-placetype="' + type.id + '">0</span>');
        if (type.category.name === '出土古墳') {
          cntElem = $('<span class="js-facet-count search-count-circle mf-af-data-count-kofun" data-placetype="' + type.id + '">0</span>');
          fcvElem = $('<label class="js-tooltip" data-kofun="' + type.name + '" data-last-child="false" data-target="place-help-' + type.id + '" parent-id="' + parent_id + '"></label>');
          if (type.name !== '百舌鳥エリア' && type.name !== '古市エリア' && ih.kofunData[type.name]) {
            fcvElem.prepend('<img class="mf-af-search-by-kofun-icon" src="' + ih.icon_file_path + ih.kofunData[type.name].icon + '.png" />')
          }
        }
        if (type.category.name === '古墳現状' || type.category.name === '出土古墳の墳形' || type.category.name === '出土古墳の墳丘長2') {
          cntElem = $('<span class="js-facet-count search-count-circle mf-af-data-count-kofun-attr" data-placetype="' + type.id + '">0</span>');
          if ( type.category.name === '出土古墳の墳形' && type.name !== '形状不明' && type.name !== '未設定' ) {
            fcvElem.prepend(`<img class="mf-af-search-by-shape-icon" src="${ih.icon_file_path}${ih.iconNameMapping[type.name]}.png" />`);
          }
          if (type.category.name === '古墳現状') {
            fcvElem.prepend(`<div class="mf-af-search-by-kofun-icon-status mf-af-search-by-kofun-icon-${ih.iconNameMapping[type.name]}"></div>`);
          }
        }
        // ファセット値のチェックボックス
        let fcvCheckbox = $('<input type="checkbox" data-mini="true" class="js-facet-selector" />'); // js-facility-selector
      
        // ファセットIDの付与
        fcvElem.attr('data-facet-id', type.category.id);
        fcvCheckbox.data('category', type.category.id);
        // ファセット値IDの付与
        fcvCheckbox.data('placetype', type.id);
        if (parent_id) {
          fcvCheckbox.data('parent_id', parent_id);
        }
        fcvCheckbox.data('hide', false);
      
        // ファセット値をチェックすると検索開始
        fcvCheckbox.on('change', function () {
          // 検索メニューを無効化する（ファセット値連打防止用）
          $('.js-search-type').addClass('ui-disabled');
          $('.mf-af-search-by-kofun').addClass('ui-disabled');
        
          // キーワード検索を初期化する
          if (ih.keywordSearchMode) {
            ih.initKeywordSearchUI();
          }
        
          $(this).trigger('changeState');
          ih.searchFromBaseMarker();
        });
      
        // ファセット値チェック状態オブジェクトの値を変更
        fcvCheckbox.on('changeState', function () {
          if (ih.isMasterServantSearchMode) {
            self.clearAllSelector();
            $(this).prop('checked', true).checkboxradio( 'refresh' );
          }
  
          let placetype = $(this).data('placetype');
          
          // 同一ファセット内で値を選択する時、別の選択済みの値の選択を解除する
          // 複数の値を選択できないようにするため
          let itemId = null;
          $('.js-facet-selector').each(function () {
            if ( $(this).data('category') === type.category.id ) {
              itemId = $(this).data('placetype');
              if ( ih.searchTargetTypes[itemId] && itemId !== placetype) {
                $(this).prop('checked', false);
                $(this).checkboxradio();
                $(this).checkboxradio('refresh');
                ih.searchTargetTypes[itemId] = false;
              }
            }
          });
        
          ih.searchTargetTypes[placetype] = $(this).get(0).checked;
        
          // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
          self.toggleAllClearButton();
        });
      
        fcvCheckbox.on('click', function () {
          this.blur();
          this.focus();
          self.OpenPopupOnSelectMenu($(this), type.category.name, type.name);
          // 検索パネルでファセット値を選んだ場合は写真一覧、出土場所パネルからファセット値を選んだ場合は地図ビューを表示する
          if ( $(this).closest('#page-search').length !== 0 ) {
            ih.forceChangeViewport('tile');
          } else if ( $(this).closest('#page-feature').length !== 0 ) {
            ih.forceChangeViewport('map');
          }
        });
      
        // 初期選択ファセット値があれば即検索
        if (type.checked) {
          fcvCheckbox.prop('checked', true);
          fcvCheckbox.trigger('changeState');
        }
      
        fcvElem.append(cntElem);
        fcvElem.append(fcvCheckbox);
      
        // ファセット値名の描画
        if (kofunFacets.indexOf(type.category.name) !== -1) {
          if (type.category.name === '出土古墳' && type.name !== '百舌鳥エリア' && type.name !== '古市エリア' && ih.kofunData[type.name]) {
            fcvElem.append($(`<span class="mf-af-search-by-kofun-name">${type.name}<span>（${ih.kofunData[type.name].length}）</span></span>`));
          } else {
            fcvElem.append($(`<span class="mf-af-search-by-kofun-name">${type.name}</span>`));
          }
        } else {
          fcvElem.append($('<span>' + type.name + '</span>'));
        }
      
        // ツールチップ生成
        if (ih.tooltipData) {
          let tooltip = _.find(ih.tooltipData, { type: type.name });
          if (tooltip) {
            // ツールチップ表示ボタン
            let tooltipTrigger =
              $('<a class="js-tooltip-trigger" data-role="button" data-theme="f" data-icon="info" data-iconpos="notext" ' +
                'data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" title=""></a>');
            tooltipTrigger.buttonMarkup("refresh");
            fcvElem.append(tooltipTrigger);
          
            // ツールチップヘッダ（ファセット値名、閉じるボタン）
            let tooltipHeader = $('<div class="ih-tooltip-header"></div>');
            let tooltipCloser = $('<button data-theme="b" data-rel="back" class="ih-tooltip-closer ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b"></button>');
            tooltipCloser.text(ih.translationsCommon.template.common.close);
            tooltipHeader.append($('<b class="ih-tooltip-title"></b>').text(type.name));
            tooltipHeader.append(tooltipCloser);
          
            // ツールチップ本体
            let tooltipContainer = $('<div class="js-tooltip-display" data-role="popup" id="place-help-' + type.id + '">');
            elem.append(tooltipContainer);
            tooltipContainer.append(tooltipHeader);
            tooltipContainer.append($('<p></p>').html(tooltip.description));
            tooltipContainer.popup();
            tooltipCloser.buttonMarkup("refresh");
          
            tooltipCloser.on('click', function () {
              tooltipContainer.popup('close');
            });
          }
        }
      
        container.append(fcvElem);
        fcvCheckbox.checkboxradio();
      }
    });
  
    // 下位階層の並べ替え
    $('.js-tooltip').each( function () {
      if ($(this).attr('parent-id') !== 'undefined') {
        let parentId = $(this).attr('parent-id');
        let lastChild = null;
      
        $(this).addClass('child');
        $(this).css('padding-left','20px');
      
        // 並べ替え済みの下位階層が存在するか
        $('.js-tooltip').each( function () {
          if ( $(this).attr('parent-id') === parentId && $(this).data('last-child') ) {
            lastChild = $(this);
            $(this).data('last-child', false);
            return false;
          }
        });
      
        // 並べ替え済みの下位階層があればその直後に、無ければ上位階層の直後に配置
        if (lastChild) {
          $(this).parent().insertAfter(lastChild.parent());
        } else {
          $(this).parent().insertAfter( $('.js-tooltip[data-target ="place-help-' + parentId + '"]').parent() );
        }
      
        $(this).data('last-child', true);
      }
    });
  
    elem.controlgroup('refresh');
  
    // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
    self.toggleAllClearButton();

    $(ih).trigger('ihRenderedSearchMenu');
  }
  
  toggleAllClearButton () {
    super.toggleAllClearButton();
    $('#all-clear-button-feature').prop('disabled', true);
    $('#all-clear-feature').find('.ui-btn-inner').css('color', 'darkgray');
    $('.js-facet-selector').each(function () {
      if ($(this).prop('checked')) {
        $('#all-clear-button-feature').prop('disabled', false);
        $('#all-clear-feature').find('.ui-btn-inner').css('color', 'black');
      }
    });
  }
  
  clearAllSelector() {
    super.clearAllSelector();
    this.ih.searchTargetTypes = [];
    if (this.ih.isMasterServantSearchMode) {
      this.ih.initMasterServantSearchMenu();
      $('.mf-af-master-servant-search-facet-value').each((index, element) => {
        $(element).prop('checked', false).checkboxradio( 'refresh' );
      });
      this.ih.isMasterServantSearchMode = false;
    }
  }
  
  displayBottomBorderOnLastMenu () {
    super.displayBottomBorderOnLastMenu();
    const $lastDisplayedFacet = $('.mf-af-search-by-kofun .ui-checkbox[style!="display: none;"] .category-label').slice(-1);
    const $lastDisplayedFacetValue = $('.mf-af-search-by-kofun .ui-checkbox[style!="display: none;"]').slice(-1).find('label');
    $lastDisplayedFacet.addClass('ih-last-facet-value');
    $lastDisplayedFacetValue.addClass('ih-last-facet-value');
  }

  /**
   * 特定のファセット値を選択すると地図ビューに切り替えてマーカーポップアップを表示する
   * 
   * @param {jQuery} $checkbox 
   * @param {String} facet 
   * @param {String} facetValue 
   */
   OpenPopupOnSelectMenu($checkbox, facet, facetValue) {
    let shouldOpenKofunPopup = false;
    let shouldOpenMuseumPopup = false;

    if ( facet === '出土古墳' && $checkbox.prop('checked') ) {
      if (facetValue !== '百舌鳥エリア' && facetValue !== '古市エリア' && this.ih.kofunData[facetValue]) {
        shouldOpenKofunPopup = true
      }
    }
    if ( facet === '展示施設' && facetValue !== 'その他（非公開含む）' && $checkbox.prop('checked') ) {
      shouldOpenMuseumPopup = true
    }

    $(this.ih.map).on('ihDisplayedAllMarkers', (event, places, marker, popup) => {
      if (shouldOpenKofunPopup) {
        shouldOpenKofunPopup = false;
        this.ih.openKofunMarkerPopup (places.pop(), marker);
      }
      if (shouldOpenMuseumPopup) {
        shouldOpenMuseumPopup = false;
        this.ih.openMuseumMarkerPopup (places.pop(), facetValue);
        const allPlaces = places.concat(Object.values(this.ih.createdMuseumPlaces));
        allPlaces.forEach(place => {
          if (
            this.ih.map.getNorthEnd() < place.lat ||
            this.ih.map.getEastEnd() < place.lng  ||
            this.ih.map.getSouthEnd() > place.lat ||
            this.ih.map.getWestEnd() > place.lng
          ) {
            this.ih.map.setZoom(this.ih.defaultZoom);
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHMozufuruArtifactController.js